import { useMediaQuery } from '@mui/material';
import React from 'react';
import LinkedInImportForm from './LinkedInImportForm';
import { Drawer } from '../shared/Drawer';

interface Props {
	isOpen?: boolean;
	onClose?: () => void;
	onProceed?: (url: string) => void;
	heading?: string;
	description?: string;
}

const LinkedInImport = ({ isOpen, onClose, onProceed, heading, description }: Props) => {
	const matches = useMediaQuery('(max-width:600px)');

	const toggleDrawer = (newOpen: boolean) => () => {
		if (!newOpen && onClose) onClose();
	};

	return (
		<div className="">
			<Drawer
				isModal={!matches}
				minHeight="fit-content"
				modalMaxWidth="414px"
				isOpen={isOpen ?? false}
				onClose={toggleDrawer(false)}
				header={<></>}
				body={
					<LinkedInImportForm
						heading={heading}
						description={description}
						toggleDrawer={toggleDrawer}
						onSuccess={onProceed}
					/>
				}
			/>
		</div>
	);
};

export default LinkedInImport;
